(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[977],{

/***/ 39294:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/exhibition/apply",
      function () {
        return __webpack_require__(55478);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 55478:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ apply; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(97582);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(93967);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./pages/exhibition/apply/index.module.scss
var index_module = __webpack_require__(98462);
var index_module_default = /*#__PURE__*/__webpack_require__.n(index_module);
// EXTERNAL MODULE: ./node_modules/@douyinfe/semi-ui/lib/es/index.js + 466 modules
var es = __webpack_require__(90978);
// EXTERNAL MODULE: ./node_modules/lodash/lodash.js
var lodash = __webpack_require__(96486);
// EXTERNAL MODULE: ./utils/useHead.tsx
var useHead = __webpack_require__(25838);
;// CONCATENATED MODULE: ./utils/index.ts
var PRODDOMAIN = "https://system.cbcechina.com";
var arrayBufferToBase64 = function(buffer) {
    var bytes = new Uint8Array(buffer);
    var binary = "";
    for(var i = 0; i < bytes.byteLength; i++){
        binary += String.fromCharCode(bytes[i]);
    }
    return window.btoa(binary);
};

// EXTERNAL MODULE: ./utils/request.ts
var request = __webpack_require__(45844);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/next-intl/dist/esm/production/react-client/index.js
var react_client = __webpack_require__(81627);
;// CONCATENATED MODULE: ./pages/exhibition/apply/index.tsx
















var Apply = function(param) {
    var menuDetail = param.menuDetail;
    var router = (0,next_router.useRouter)();
    var t = (0,react_client/* useTranslations */.T_)("exhibition.apply");
    var transOption = (0,react.useCallback)(function() {
        var list = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
        return list === null || list === void 0 ? void 0 : list.map(function(item) {
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, item), {
                key: item.id,
                value: item.id,
                label: router.locale == "en" ? item.name_en : item.name_cn
            });
        });
    }, []);
    var transTree = (0,react.useCallback)(function() {
        var list = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
        return list === null || list === void 0 ? void 0 : list.map(function(item) {
            var ref;
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, item), {
                key: String(item.id),
                value: item.id,
                label: router.locale == "en" ? item.name_en : item.name_cn,
                children: ((ref = item.childlist) === null || ref === void 0 ? void 0 : ref.length) > 0 ? transTree(item.childlist) : []
            });
        });
    }, []);
    var ref = (0,react.useState)([]), country_list = ref[0], setCountryList = ref[1];
    var getCountryList = (0,react.useCallback)(/*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
        var data;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        request/* default.get */.Z.get("/api/get_country")
                    ];
                case 1:
                    data = _state.sent().data;
                    setCountryList(transOption(data === null || data === void 0 ? void 0 : data.data));
                    return [
                        2
                    ];
            }
        });
    }), []);
    var ref1 = (0,react.useState)([]), category_list = ref1[0], setCategoryList = ref1[1];
    var getCategoryList = (0,react.useCallback)(/*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
        var data;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        request/* default.get */.Z.get("/api/product_category_list")
                    ];
                case 1:
                    data = _state.sent().data;
                    setCategoryList(transTree(data === null || data === void 0 ? void 0 : data.data));
                    return [
                        2
                    ];
            }
        });
    }), []);
    var ref2 = (0,react.useState)(""), verify_img = ref2[0], setVerifyImg = ref2[1];
    var ref3 = (0,react.useState)(""), verify_cookie = ref3[0], setVerifyCookie = ref3[1];
    var ref4 = (0,react.useState)(""), verify_code = ref4[0], setVerifyCode = ref4[1];
    var getVerify = (0,react.useCallback)(/*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
        var ref, ref1, ref2, data;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        request/* default.get */.Z.get("/api/get_verify")
                    ];
                case 1:
                    data = _state.sent().data;
                    setVerifyImg("data:image/png;base64," + arrayBufferToBase64(data === null || data === void 0 ? void 0 : (ref = data.data) === null || ref === void 0 ? void 0 : (ref1 = ref.img) === null || ref1 === void 0 ? void 0 : ref1.data));
                    setVerifyCookie(data === null || data === void 0 ? void 0 : (ref2 = data.data) === null || ref2 === void 0 ? void 0 : ref2["cbce-verify-cookie"]);
                    return [
                        2
                    ];
            }
        });
    }), []);
    var ref5 = (0,react.useState)([]), province_list = ref5[0], setProvinceList = ref5[1];
    var ref6 = (0,react.useState)([]), city_list = ref6[0], setCityList = ref6[1];
    var ref7 = (0,react.useState)(false), regionVisible = ref7[0], setRegionVisible = ref7[1];
    var getRegion = (0,react.useCallback)(function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(pid) {
            var data, _list;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            request/* default.get */.Z.get("/api/get_region", {
                                params: {
                                    pid: pid
                                }
                            })
                        ];
                    case 1:
                        data = _state.sent().data;
                        _list = transOption((0,lodash.toArray)(data === null || data === void 0 ? void 0 : data.data));
                        !!pid ? setCityList(_list) : setProvinceList(_list);
                        return [
                            2
                        ];
                }
            });
        });
        return function(pid) {
            return _ref.apply(this, arguments);
        };
    }(), []);
    var formRef = (0,react.useRef)();
    var renderLabel = function(param) {
        var className = param.className, onExpand = param.onExpand, data = param.data, onCheck = param.onCheck, checkStatus = param.checkStatus, expandIcon = param.expandIcon;
        var label = data.label;
        var isLeaf = !(data.children && data.children.length);
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
            className: className,
            role: "treeitem",
            onClick: isLeaf ? onCheck : onExpand,
            children: [
                isLeaf ? null : expandIcon,
                isLeaf ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    tabIndex: 0,
                    "aria-checked": checkStatus.checked,
                    onClick: onCheck
                }) : null,
                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    style: {
                        marginLeft: isLeaf ? "20px" : ""
                    },
                    children: label
                })
            ]
        });
    };
    var submit = (0,react.useCallback)(function() {
        formRef.current.validate().then(/*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
            var data;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (formRef.current.getValue("booth_type") == "1" && formRef.current.getValue("booth_input1") < 18) {
                            return [
                                2,
                                es/* Toast.warning */.FN.warning({
                                    content: t("section2.item14mes1"),
                                    duration: 3
                                })
                            ];
                        }
                        if (formRef.current.getValue("booth_type") == "2" && formRef.current.getValue("booth_input2") < 9) {
                            return [
                                2,
                                es/* Toast.warning */.FN.warning({
                                    content: t("section2.item14mes2"),
                                    duration: 3
                                })
                            ];
                        }
                        if (!verify_code) {
                            return [
                                2,
                                es/* Toast.warning */.FN.warning({
                                    content: t("section2.item13mes1"),
                                    duration: 3
                                })
                            ];
                        }
                        return [
                            4,
                            request/* default.post */.Z.post("/api/exhibitor_apply", (0,_object_spread/* default */.Z)({
                                lang: router.locale,
                                captcha: verify_code
                            }, formRef.current.getFormState().values), {
                                headers: {
                                    "cbce-verify-cookie": verify_cookie
                                }
                            })
                        ];
                    case 1:
                        data = _state.sent().data;
                        if (data.code == 1) {
                            es/* Toast.success */.FN.success({
                                content: t("success"),
                                duration: 3
                            });
                            formRef.current.reset();
                        } else {
                            getVerify();
                            es/* Toast.error */.FN.error({
                                content: data.msg,
                                duration: 3
                            });
                        }
                        return [
                            2
                        ];
                }
            });
        })).catch(function(err) {
            es/* Toast.warning */.FN.warning({
                content: t("failed"),
                duration: 3
            });
        });
    }, [
        verify_code,
        verify_cookie
    ]);
    (0,react.useEffect)(function() {
        getCountryList();
        getCategoryList();
        getVerify();
        getRegion(0);
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (index_module_default()).container,
            children: [
                (0,useHead/* getHead */.c)(menuDetail),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (index_module_default()).content,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            className: (index_module_default()).banner,
                            src: "https://img.cbcechina.com/2026-04-02/fa889ced9c0cccc9013421c9b5e66890.jpg",
                            alt: ""
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (index_module_default()).form,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (index_module_default()).head,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("h2", {
                                            className: (index_module_default()).title,
                                            children: [
                                                t("title"),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    children: t("text")
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: (index_module_default()).btns,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                    href: "/",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                        className: classnames_default()((index_module_default()).btn, (index_module_default()).red),
                                                        children: t("btn1")
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                    href: t("btn2link"),
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                        className: classnames_default()((index_module_default()).btn),
                                                        target: "_blank",
                                                        children: t("btn2")
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Form */.l0, {
                                    getFormApi: function(formApi) {
                                        return formRef.current = formApi;
                                    },
                                    labelPosition: "left",
                                    labelWidth: router.locale == "en" ? "160px" : "108px",
                                    labelAlign: "right",
                                    children: function(param) {
                                        var formState = param.formState, values = param.values, formApi = param.formApi;
                                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("h3", {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            children: "*"
                                                        }),
                                                        t("section1.title")
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(es/* Form.RadioGroup */.l0.RadioGroup, {
                                                    className: (index_module_default()).type,
                                                    field: "booth_type",
                                                    noLabel: true,
                                                    direction: "vertical",
                                                    rules: [
                                                        {
                                                            required: true,
                                                            message: t("section1.message")
                                                        }, 
                                                    ],
                                                    onChange: function() {
                                                        formRef.current.reset([
                                                            "booth_input1",
                                                            "booth_input2"
                                                        ]);
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Form.Radio */.l0.Radio, {
                                                            value: "1",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                className: (index_module_default()).item,
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                        style: {
                                                                            width: router.locale == "en" ? "116px" : "65px"
                                                                        },
                                                                        children: [
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                                className: (index_module_default()).tit,
                                                                                children: t("section1.item1tit")
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                                className: (index_module_default()).txt,
                                                                                children: t("section1.item1txt")
                                                                            })
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Form.InputNumber */.l0.InputNumber, {
                                                                        field: "booth_input1",
                                                                        noLabel: true,
                                                                        placeholder: t("section1.item1tip"),
                                                                        addonAfter: t("section1.item1sub"),
                                                                        disabled: formRef.current.getValue("booth_type") != "1",
                                                                        hideButtons: true,
                                                                        trigger: "blur",
                                                                        rules: [
                                                                            {
                                                                                required: formRef.current.getValue("booth_type") == "1",
                                                                                message: t("section1.item1mes")
                                                                            }, 
                                                                        ]
                                                                    })
                                                                ]
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Form.Radio */.l0.Radio, {
                                                            value: "2",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                className: (index_module_default()).item,
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                        style: {
                                                                            width: router.locale == "en" ? "116px" : "65px"
                                                                        },
                                                                        children: [
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                                className: (index_module_default()).tit,
                                                                                children: t("section1.item2tit")
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                                className: (index_module_default()).txt,
                                                                                children: t("section1.item2txt")
                                                                            })
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Form.InputNumber */.l0.InputNumber, {
                                                                        field: "booth_input2",
                                                                        noLabel: true,
                                                                        placeholder: t("section1.item2tip"),
                                                                        addonAfter: t("section1.item2sub"),
                                                                        disabled: formRef.current.getValue("booth_type") != "2",
                                                                        hideButtons: true,
                                                                        trigger: "blur",
                                                                        rules: [
                                                                            {
                                                                                required: formRef.current.getValue("booth_type") == "2",
                                                                                message: t("section1.item2mes")
                                                                            }, 
                                                                        ]
                                                                    })
                                                                ]
                                                            })
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("h3", {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            children: "*"
                                                        }),
                                                        t("section2.title")
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Form.Input */.l0.Input, {
                                                    field: router.locale == "en" ? "company_en" : "company_cn",
                                                    label: t("section2.item1tit"),
                                                    placeholder: t("section2.item1tip"),
                                                    trigger: "blur",
                                                    rules: [
                                                        {
                                                            required: true,
                                                            message: t("section2.item1mes1")
                                                        },
                                                        {
                                                            validator: function(rule, value) {
                                                                return !!value;
                                                            },
                                                            message: t("section2.item1mes2")
                                                        }
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Form.Input */.l0.Input, {
                                                    field: "truename",
                                                    label: t("section2.item2tit"),
                                                    placeholder: t("section2.item2tip"),
                                                    trigger: "blur",
                                                    rules: [
                                                        {
                                                            required: true,
                                                            message: t("section2.item2mes1")
                                                        },
                                                        {
                                                            validator: function(rule, value) {
                                                                return !!value;
                                                            },
                                                            message: t("section2.item2mes2")
                                                        }
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Form.InputNumber */.l0.InputNumber, {
                                                    field: "mobile",
                                                    label: t("section2.item3tit"),
                                                    hideButtons: true,
                                                    placeholder: t("section2.item3tip"),
                                                    trigger: "blur",
                                                    rules: [
                                                        {
                                                            required: true,
                                                            message: t("section2.item3mes1")
                                                        },
                                                        {
                                                            validator: function(rule, value) {
                                                                return !!value;
                                                            },
                                                            message: t("section2.item3mes2")
                                                        }
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(es/* Form.RadioGroup */.l0.RadioGroup, {
                                                    className: (index_module_default()).gender,
                                                    field: "gender",
                                                    label: t("section2.item4tit"),
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Form.Radio */.l0.Radio, {
                                                            value: "1",
                                                            children: t("section2.item4val1")
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Form.Radio */.l0.Radio, {
                                                            value: "2",
                                                            children: t("section2.item4val2")
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Form.Input */.l0.Input, {
                                                    field: "position",
                                                    label: t("section2.item5tit"),
                                                    placeholder: t("section2.item5tip"),
                                                    trigger: "blur"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Form.Select */.l0.Select, {
                                                    field: "country_id",
                                                    label: t("section2.item6tit"),
                                                    placeholder: t("section2.item6tip"),
                                                    onSelect: function(value, option) {
                                                        formRef.current.setValue("phone_code", "+" + option.code);
                                                        setRegionVisible(value == 256);
                                                    },
                                                    rules: [
                                                        {
                                                            required: true,
                                                            message: t("section2.item6mes1")
                                                        }, 
                                                    ],
                                                    optionList: country_list
                                                }),
                                                regionVisible && /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Form.Slot */.l0.Slot, {
                                                    label: {
                                                        text: t("section2.item7tit"),
                                                        required: true
                                                    },
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: (index_module_default()).grid_2,
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Form.Select */.l0.Select, {
                                                                field: "province_id",
                                                                noLabel: true,
                                                                placeholder: t("section2.item7tip1"),
                                                                rules: [
                                                                    {
                                                                        required: true,
                                                                        message: t("section2.item7mes1")
                                                                    }, 
                                                                ],
                                                                optionList: province_list,
                                                                onSelect: function(value, option) {
                                                                    getRegion(value);
                                                                    formRef.current.reset([
                                                                        "city_id"
                                                                    ]);
                                                                }
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Form.Select */.l0.Select, {
                                                                field: "city_id",
                                                                noLabel: true,
                                                                placeholder: t("section2.item7tip2"),
                                                                rules: [
                                                                    {
                                                                        required: true,
                                                                        message: t("section2.item7mes2")
                                                                    }, 
                                                                ],
                                                                optionList: city_list,
                                                                onSelect: function(value, option) {
                                                                    formRef.current.setValue("phone_zone", option.area_code);
                                                                }
                                                            })
                                                        ]
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Form.Slot */.l0.Slot, {
                                                    label: {
                                                        text: t("section2.item8tit")
                                                    },
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: (index_module_default()).grid_3,
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Form.Input */.l0.Input, {
                                                                className: (index_module_default()).input,
                                                                field: "phone_code",
                                                                noLabel: true,
                                                                readonly: true,
                                                                initValue: "+86"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Form.Input */.l0.Input, {
                                                                className: (index_module_default()).input,
                                                                field: "phone_zone",
                                                                placeholder: t("section2.item8tip1"),
                                                                noLabel: true
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Form.InputNumber */.l0.InputNumber, {
                                                                className: (index_module_default()).input,
                                                                hideButtons: true,
                                                                field: "phone",
                                                                placeholder: t("section2.item8tip2"),
                                                                noLabel: true
                                                            })
                                                        ]
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Form.Input */.l0.Input, {
                                                    field: "email",
                                                    label: t("section2.item9tit"),
                                                    placeholder: t("section2.item9tip"),
                                                    trigger: "blur",
                                                    rules: [
                                                        {
                                                            required: true,
                                                            message: t("section2.item9mes1")
                                                        },
                                                        {
                                                            validator: function(rule, value) {
                                                                return !!value;
                                                            },
                                                            message: t("section2.item9mes2")
                                                        }
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Form.Input */.l0.Input, {
                                                    field: "website",
                                                    label: t("section2.item10tit"),
                                                    placeholder: t("section2.item10tip")
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: (index_module_default()).grid_2,
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Form.Input */.l0.Input, {
                                                            field: "company_type",
                                                            label: t("section2.item11tit"),
                                                            placeholder: t("section2.item11tip")
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Form.TreeSelect */.l0.TreeSelect, {
                                                            field: "category_data",
                                                            label: t("section2.item12tit"),
                                                            labelWidth: router.locale == "en" ? "160px" : "108px",
                                                            dropdownStyle: {
                                                                maxHeight: 400,
                                                                overflow: "auto"
                                                            },
                                                            treeData: category_list,
                                                            placeholder: t("section2.item12tip"),
                                                            disableStrictly: true,
                                                            leafOnly: true,
                                                            renderFullLabel: renderLabel,
                                                            rules: [
                                                                {
                                                                    required: true,
                                                                    message: t("section2.item12mes1")
                                                                }, 
                                                            ]
                                                        })
                                                    ]
                                                })
                                            ]
                                        });
                                    }
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Input */.II, {
                                    className: (index_module_default()).verify,
                                    placeholder: t("section2.item13tip"),
                                    addonAfter: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        className: (index_module_default()).code,
                                        src: verify_img,
                                        alt: "",
                                        onClick: function() {
                                            return getVerify();
                                        }
                                    }),
                                    value: verify_code,
                                    onChange: function(e) {
                                        return setVerifyCode(e);
                                    }
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (index_module_default()).button,
                                    onClick: submit,
                                    children: t("btn3")
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: (index_module_default()).copyright,
                    children: t("copyright")
                })
            ]
        })
    });
};
var __N_SSP = true;
/* harmony default export */ var apply = (Apply);


/***/ }),

/***/ 25838:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "c": function() { return /* binding */ getHead; }
/* harmony export */ });
/* unused harmony export getServerSideProps */
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(97582);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _utils_request__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(45844);





var getMenuCurrent = function(menu, path) {
    for(var i = 0; i < (menu === null || menu === void 0 ? void 0 : menu.length); i++){
        var item = menu[i];
        if (item.pathinfo === path) {
            return item;
        }
        if (item.childlist && Array.isArray(item.childlist)) {
            var child = getMenuCurrent(item.childlist, path);
            if (child) {
                return child;
            }
        }
    }
    return null;
};
var getServerSideProps = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(function(context, menuId) {
        var ref, ref1, ref2, _menu, menuCurrent, ref3, _data;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_4__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        _utils_request__WEBPACK_IMPORTED_MODULE_2__/* ["default"].get */ .Z.get("/api/menu", {
                            params: {
                                lang: (context === null || context === void 0 ? void 0 : context.locale) || "cn"
                            }
                        })
                    ];
                case 1:
                    ref2 = _state.sent(), _menu = ref2.data;
                    menuCurrent = getMenuCurrent(_menu === null || _menu === void 0 ? void 0 : (ref = _menu.data) === null || ref === void 0 ? void 0 : ref.menu_tree, context === null || context === void 0 ? void 0 : (ref1 = context.resolvedUrl) === null || ref1 === void 0 ? void 0 : ref1.split("?")[0]);
                    return [
                        4,
                        _utils_request__WEBPACK_IMPORTED_MODULE_2__/* ["default"].get */ .Z.get("/api/menu_info/".concat(menuId || (menuCurrent === null || menuCurrent === void 0 ? void 0 : menuCurrent.id)), {
                            params: {
                                lang: (context === null || context === void 0 ? void 0 : context.locale) || "cn"
                            }
                        })
                    ];
                case 2:
                    ref3 = _state.sent(), _data = ref3.data;
                    return [
                        2,
                        {
                            props: {
                                menuDetail: _data.data || null
                            }
                        }
                    ];
            }
        });
    });
    return function getServerSideProps(context, menuId) {
        return _ref.apply(this, arguments);
    };
}();
var getHead = function(menuDetail) {
    var ref, ref1, ref2, ref3, ref4, ref5;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_1___default()), {
        children: [
            (menuDetail === null || menuDetail === void 0 ? void 0 : (ref = menuDetail.info) === null || ref === void 0 ? void 0 : ref.meta_title) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                children: menuDetail === null || menuDetail === void 0 ? void 0 : (ref1 = menuDetail.info) === null || ref1 === void 0 ? void 0 : ref1.meta_title
            }),
            (menuDetail === null || menuDetail === void 0 ? void 0 : (ref2 = menuDetail.info) === null || ref2 === void 0 ? void 0 : ref2.meta_kws) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "keywords",
                content: menuDetail === null || menuDetail === void 0 ? void 0 : (ref3 = menuDetail.info) === null || ref3 === void 0 ? void 0 : ref3.meta_kws
            }),
            (menuDetail === null || menuDetail === void 0 ? void 0 : (ref4 = menuDetail.info) === null || ref4 === void 0 ? void 0 : ref4.meta_desc) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "description",
                content: menuDetail === null || menuDetail === void 0 ? void 0 : (ref5 = menuDetail.info) === null || ref5 === void 0 ? void 0 : ref5.meta_desc
            })
        ]
    });
};



/***/ }),

/***/ 98462:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"m-1600":"apply_m-1600__sTBco","container":"apply_container__uqiD0","content":"apply_content__hj7nQ","banner":"apply_banner__1Jewp","form":"apply_form__yAE_e","head":"apply_head__ESfHB","title":"apply_title__UGP1N","btns":"apply_btns__nBLsr","btn":"apply_btn__iocvM","red":"apply_red__gCNuq","type":"apply_type__NjtbQ","item":"apply_item__9bb4c","tit":"apply_tit__ldW3k","txt":"apply_txt__Keb6U","gender":"apply_gender__uWtek","grid_2":"apply_grid_2__FE5Rn","grid_3":"apply_grid_3__OOEpb","verify":"apply_verify__PSbgG","code":"apply_code__GWNbP","button":"apply_button__hMP5U","copyright":"apply_copyright__92X1w"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [662,774,888,179], function() { return __webpack_exec__(39294); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);